<template>
  <div class="integration-option text-center ">
    <section v-if="!isPartner" class="integration-option-enable">
      <v-checkbox class="integration-option-enable-checkbox"
                  hide-details
                  v-model="showIntegrationOptions"
                  @change="checkIfDeleteIntegration"></v-checkbox>
      <h6 class="integration-option-enable-title">{{$t('message.campaigns.message.enableIntegration')}}</h6>
    </section>
    <section v-if="showIntegrationOptions"
             class="integration-option-select">
      <app-select :data-title="$t('message.campaigns.message.integration')"
                  v-model="integration"
                  :data-items="integrationsSelectOptionsWithFilter"
                  @input="selectIntegration"
                  @search="v => search(v)"
                  :no-results="noResults"
                  :clearable="false">
      </app-select>
    </section>
  </div>
</template>
<script>
    import EventBus from '@packages/event-bus'

    import AppSelect from '@components/Select'

  export default {
    components: {
      AppSelect
    },
    props: {
      interactionData: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        integration: null,
        showIntegrationOptions: false,
        filteredList: [],
        searchedText: undefined,
        noResults: false
      }
    },
    async created() {
      try {
        await this.$loader.integrations.loadIntegrationsAccessExecution()
      } catch (error) {
        console.log(error)
      }
    },
    mounted() {
      if(this.interactionData.hookId) {
        this.integration = this.interactionData.hookId;
        this.showIntegrationOptions = true;
      }
    },
    computed: {
      user() {
        return this.$store.state.users.user;
      },
      integrations() {
        return this.$store.state.integration.listIntegrationsAccessExecution;
      },
      integrationOptions() {
        return this.integrations && this.integrations.map((integration) => {
          return {
            id: integration.id,
            label: integration.name
          }
        })
      },
      integrationsSelectOptionsWithFilter() {
        return this.filteredList.length > 0 ? this.filteredList : this.integrationOptions
      },
      isPartner() {
        return this.$store.state.users.user.tipo === "PARCEIRO";
      },
    },
    methods: {
      async selectIntegration(integrationId) {
        const res = await this.$api.interactions.setIntegration({
          advertisingId: this.interactionData.campanhaId,
          integrationId,
          interactionId: this.interactionData.id
        });
        EventBus.$emit('show-message', {
          type: 'SUCCESS',
          message: res.message
        })

        this.$emit('change', this.integration)

      },
      async checkIfDeleteIntegration(val) {
        if(!val) {
          await this.$api.interactions.unsetIntegration({
            advertisingId: this.interactionData.campanhaId,
            interactionId: this.interactionData.id
          })

          this.integration = null;
          this.$emit('change', this.integration)
        }
      },
      search(search) {
        if(!search) {
          this.noResults = false
        }
        this.searchedText = search
        this.filteredList = this.integrationOptions.filter(item => item.label.toLowerCase().includes(search.toLowerCase()))
        if(this.filteredList.length < 1)
          this.noResults = true
      },
    }
  }
</script>


<style lang="scss" scoped>
.integration-option {
  .integration-option-enable {
    display: flex;
    align-items: center;
    justify-content: start;

    .integration-option-enable-checkbox {
      flex: 0;
      padding: 0;
    }

    .integration-option-enable-title {
      margin: 0;
    }
  }

  .integration-option-select {
    margin: 5px 0;
    display: flex;
    justify-content: center;
  }
}
</style>
